// FILECONTENT_START src/common/components/DataGrid/DataGridToolbarQuickSearch.tsx
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import { alpha, InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { createTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import I18n from "i18n-js";
import { TextField } from "../Inputs";
import { DataGridToolbarProps } from "./DataGridToolbar";
import DataGridToolbarButtonContainer from "./toolbar-buttons/DatagridToolbarButtonContainer";

const defaultTheme = createTheme();
const useStyles = makeStyles(
  (theme: any) =>
    createStyles({
      row: {
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
      },
      root: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: "space-between",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
      },
      rootOnlyTrashed: {
        padding: theme.spacing(0.5, 0.5, 0),
        justifyContent: "space-between",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        backgroundColor: alpha(theme.palette.warning.main, 0.2),
      },
      textField: {
        width: "auto",
        [theme.breakpoints.down("xs")]: {
          width: "100%",
        },
        margin: theme.spacing(1, 0.5, 1.5),
        "& .MuiSvgIcon-root": {
          marginRight: theme.spacing(0.5),
        },
        "& .MuiInput-underline:before": {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
      },
      searchInput: {
        borderRadius: "1999px!important",
        color: "white",
        //backgroundColor: alpha(theme.palette.primary.dark, 0.6),
        margin: "0 auto",
        "&:not(.Mui-disabled):hover": {
          //borderColor: `${theme.palette.primary.light}!important`,
        },
        "& .MuiOutlinedInput-notchedOutline": {
          //borderColor: `${theme.palette.primary.light}!important`,
          borderRadius: "1999px!important",
        },
        "& .MuiOutlinedInput-input": {
          padding: "6.5px 5px",
        },
        "&.Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            //borderColor: `${theme.palette.primary.light}!important`,
          },
        },
      },
    }),
  { defaultTheme }
);

export interface DataGridToolbarQuickSearchProps extends DataGridToolbarProps {}

export default function DataGridToolbarQuickSearch(
  props: DataGridToolbarQuickSearchProps
) {
  const { clearSearch, onChange, value, buttonSize } = props;
  const classes = useStyles();

  return (
    <DataGridToolbarButtonContainer>
      <TextField
        useDelayedKeystrokes
        variant="outlined"
        value={value}
        onChange={onChange}
        placeholder={I18n.t("App.search")}
        className={classes.searchInput}
        InputProps={{
          startAdornment: (
            <InputAdornment
              position="start"
              style={{
                marginLeft: -6,
                marginRight: 0,
                marginBottom: -2,
                marginTop: 2,
              }}
            >
              <SearchIcon color="action" fontSize={buttonSize} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" style={{ marginRight: -6 }}>
              <IconButton
                title="Clear"
                aria-label="Clear"
                size={"small"}
                style={{ visibility: value ? "visible" : "hidden" }}
                onClick={clearSearch}
              >
                <ClearIcon fontSize={"small"} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </DataGridToolbarButtonContainer>
  );
}

// FILECONTENT_END src/common/components/DataGrid/DataGridToolbarQuickSearch.tsx